import { DomHelper } from "./domHelper";
import { getBackendData, sendBackendData } from "./xhrbackend";
import { Util } from "./util";
import { DEBUG, DEFAULT_PREFS } from "./config";
import { getAppCardNode } from './appCardDefault';
import { DataStore } from "./dataStore";
import { getSchoolAdminMainStructure } from "./appSchoolAdmin";
let ds = new DataStore();
const functionList = [
    { label: "Klassenzuweisung", help: "Zuordnung von Lernenden zu Klassen.", type: "pupil" },
    { label: "Klassen", help: "Pflege der Grunddaten für Klassen, Name, Gültigkeit etc.", type: "classes" },
];
export function appSchoolAdminInviteRender(username, bearerToken, parentNode, app, userResponse) {
    if (DEBUG)
        console.log("-->appSchoolAdminInviteRender");
    const additionalClassList = [];
    if (!userResponse.odDeskPreferences)
        userResponse.odDeskPreferences = DEFAULT_PREFS;
    const cardNode = getAppCardNode(parentNode, app, username, userResponse.odDeskPreferences, bearerToken, false, additionalClassList, null, (event) => {
        handleClickOpen(event, username, bearerToken, userResponse.odDeskPreferences);
    });
}
function appPartSchoolSelectorRender(injectNode, username, userPreferences, data, bearerToken) {
    const schoolNode = DomHelper.appendNode(injectNode, 'div', ['form-group']);
    DomHelper.appendNode(schoolNode, 'label', ['form-label', 'mb-0', 'mt-2'], [{ attr: 'for', value: 'rudi-tt-form-school' }], "Wählen Sie eine Schule");
    const selectNode = DomHelper.appendNode(schoolNode, 'select', ['form-select'], [{ attr: 'id', value: 'rudi-admin-form-school' }]);
    DomHelper.appendNode(selectNode, 'option', [], [
        { attr: 'value', value: "empty" }
    ], "-- Bitte Schule wählen --- ");
    for (let school of data) {
        DomHelper.appendNode(selectNode, 'option', [], [
            { attr: 'value', value: school.id }
        ], school.longname);
    }
    selectNode.addEventListener('change', function (event) {
        const selectNode = document.getElementById('rudi-admin-form-school');
        if (selectNode) {
            console.log(selectNode.value);
        }
        getBackendData(username, "/school/" + selectNode.value + "/", "GET", "application/json", bearerToken, function (response) {
            const responseData = JSON.parse(response.target.response);
            console.log(responseData);
            const classes = responseData[0].classes;
            const schoolUUID = responseData[0].id;
            if (schoolUUID != "empty") {
                getBackendData('', `/invite/groups?schoolid=${schoolUUID}`, "GET", "application/json", bearerToken, function (response) {
                    const responseData = JSON.parse(response.target.response);
                    console.log(responseData);
                    console.log("Classes", classes);
                    appPartSchoolGridRender(schoolUUID, responseData, bearerToken);
                });
            }
        });
    });
}
function renderClassUpdate(classItem, schoolid, bearerToken) {
    const trNode = document.getElementById(classItem.id);
    if (trNode) {
        trNode.innerHTML = "";
        addClassInfo(trNode, schoolid, classItem, bearerToken);
    }
}
function renderClassCreate(classItem, schoolUUID, bearerToken) {
    const tbodyNode = document.getElementById('rudi-class-table-body');
    if (tbodyNode) {
        renderGridRowClass(tbodyNode, classItem, schoolUUID, bearerToken);
    }
}
function creatClassForm(bearerToken, formNode, schoolid, classItem, modalNode, shortnameReadonly = true) {
    DomHelper.appendInputText(formNode, "id", [], [], 'id', '', classItem.id, [{
            attr: "readonly",
            value: 'true'
        }, { attr: "hidden", value: 'true' }]);
    let shortnameAttr = shortnameReadonly ? [{
            attr: "readonly",
            value: 'true'
        }] : [{
            attr: 'pattern',
            value: '[A-Za-z0-9]+'
        },
        {
            attr: 'title',
            value: 'Darf nur aus Buchstaben und Zahlen ohne Leerzeichen bestehen.'
        }];
    DomHelper.appendInputText(formNode, "shortname", [], [], 'shortname', 'Kürzel', classItem.shortname, shortnameAttr);
    DomHelper.appendInputText(formNode, "longname", [], [], 'longname', 'Bezeichnung (lang) wird verwendet z.B. Chatraum Name', classItem.longname, []);
    DomHelper.appendInputText(formNode, "von", [], [], 'von', 'Beginn', Util.isoString2DateString(classItem.von), []);
    DomHelper.appendInputText(formNode, "bis", [], [], 'bis', 'Ende', classItem.bis == "" || classItem.bis == null ? "" : Util.isoString2DateString(classItem.bis), []);
    let teacherNameKeys = [];
    if (classItem.teachers) {
        for (let teacher of classItem.teachers) {
            let odNK = {
                id: teacher.cn,
                name: teacher.displayName
            };
            teacherNameKeys.push(odNK);
        }
    }
    DomHelper.appendMultiNameSelect(formNode, "teacher", [], [], 'teacher', 'Lehrkräfte', bearerToken, schoolid, classItem.id, teacherNameKeys);
    const section = DomHelper.appendNode(formNode, 'section', ['rudi-form-input-group'], []);
    const buttonCloseNode = DomHelper.appendNode(section, "button", ['btn', 'btn-secondary'], [{
            attr: "classid",
            value: classItem.id
        }], '');
    DomHelper.appendNode(buttonCloseNode, 'i', ['fa-light', 'fa-circle-xmark']);
    DomHelper.appendNode(buttonCloseNode, 'span', [], [], 'Schließen');
    buttonCloseNode.addEventListener('click', function (event) {
        event.preventDefault();
        modalNode.style.display = 'none';
    });
    const nodeSearchBox = document.getElementById('rudi-multi-searchbox-input');
    const resultArea = document.getElementById('rudi-multi-searchbox-result');
    if (nodeSearchBox && resultArea) {
        nodeSearchBox.addEventListener('change', function (event) {
            handleSearchBox(bearerToken, schoolid, classItem.id, nodeSearchBox, resultArea);
        });
    }
    return section;
}
function handleSearchBox(bearerToken, schoolid, classid, searchBox, resultArea) {
    const query = searchBox.value;
    if (query.length < 3) {
        resultArea.innerHTML = '';
        return;
    }
    resultArea.innerHTML = '';
    getBackendData('', `/school/teachers/search/?search=${query}`, "GET", "application/json", bearerToken, function (response) {
        const responseData = JSON.parse(response.target.response);
        console.log(responseData);
        for (let teacher of responseData) {
            const nodeTeacher = DomHelper.appendNode(resultArea, 'div', ['rudi-search-add-item'], [], teacher.displayName);
            DomHelper.appendNode(nodeTeacher, 'i', ['fa-light', 'fa-user-plus'], []);
            nodeTeacher.addEventListener('click', function (event) {
                searchBox.value = "";
                resultArea.innerHTML = "";
                handleAddTeacher2Class(bearerToken, schoolid, classid, teacher.cn, teacher.displayName);
            });
        }
    });
}
function handleAddTeacher2Class(bearerToken, schoolid, classid, teacherCN, teacherDisplayNAme) {
    console.log("-->handleAddTeacher2Class", schoolid, classid, teacherCN, teacherDisplayNAme);
    sendBackendData('', `/school/${schoolid}/class/${classid}/teacher/${teacherCN}`, 'PUT', 'application/json', bearerToken, {}, (response) => {
        const responseData = JSON.parse(response.target.response);
        console.log(responseData);
        handleUpdateAddTeacher2Class(bearerToken, schoolid, classid, teacherCN, teacherDisplayNAme);
    });
}
function handleUpdateAddTeacher2Class(bearerToken, schoolid, classid, teacherCN, teacherDisplayNAme) {
    console.log("-->handleUpdateAddTeacher2Class", teacherCN, teacherDisplayNAme);
    const nodeResult = document.getElementById('rudi-form-multiName-group-selected');
    DomHelper.renderNameKeyobject(nodeResult, { id: teacherCN, name: teacherDisplayNAme }, bearerToken, schoolid, classid);
}
function handleClassCreate(schoolid, bearerToken, event) {
    const modalNode = document.getElementById('rudi-modal');
    const modalContentNode = document.getElementById('rudi-modal-content');
    const today = new Date();
    const vonString = today.toISOString();
    const classItem = {
        id: '',
        longname: 'Neue Klasse',
        shortname: 'nk',
        von: vonString,
        groups: []
    };
    if (modalNode && modalContentNode) {
        DomHelper.showModal(modalNode);
        const titleNode = document.getElementById('rudi-modal-title');
        if (titleNode)
            titleNode.innerHTML = "Neue Klasse anlegen";
        const formNode = document.getElementById('rudi-modal-form');
        if (formNode) {
            formNode.innerHTML = "";
            const section = creatClassForm(bearerToken, formNode, schoolid, classItem, modalNode, false);
            const buttonSafeNode = DomHelper.appendNode(section, "button", ['btn', 'btn-secondary'], [{ attr: "classid", value: classItem.id }], '');
            DomHelper.appendNode(buttonSafeNode, 'i', ['fa-light', 'fa-cloud-arrow-up']);
            DomHelper.appendNode(buttonSafeNode, 'span', [], [], 'Klasse speichern');
            buttonSafeNode.addEventListener('click', function (event) {
                event.preventDefault();
                console.log("safe", formNode);
                const formData = new FormData(formNode);
                let schoolClass = {
                    id: formData.get('id') ? formData.get('id') : '',
                    longname: formData.get('longname') ? formData.get('longname') : '',
                    shortname: formData.get('shortname') ? formData.get('shortname') : '',
                    von: formData.get('von') ? Util.string2IsoString(formData.get('von')) : '',
                    bis: formData.get('bis') ? Util.string2IsoString(formData.get('bis')) : ''
                };
                modalNode.style.display = 'none';
                sendBackendData('', `/school/${schoolid}/class/`, 'POST', 'application/json', bearerToken, schoolClass, (response) => {
                    const responseData = JSON.parse(response.target.response);
                    renderClassCreate(responseData, schoolid, bearerToken);
                });
            });
        }
    }
}
function handleClassEdit(schoolid, classItem, bearerToken, event) {
    const modalNode = document.getElementById('rudi-modal');
    const modalContentNode = document.getElementById('rudi-modal-content');
    if (modalNode && modalContentNode) {
        DomHelper.showModal(modalNode);
        const titleNode = document.getElementById('rudi-modal-title');
        if (titleNode)
            titleNode.innerHTML = "Klasse bearbeiten";
        const formNode = document.getElementById('rudi-modal-form');
        if (formNode) {
            formNode.innerHTML = "";
            const section = creatClassForm(bearerToken, formNode, schoolid, classItem, modalNode);
            const buttonSafeNode = DomHelper.appendNode(section, "button", ['btn', 'btn-secondary'], [{ attr: "classid", value: classItem.id }], '');
            DomHelper.appendNode(buttonSafeNode, 'i', ['fa-light', 'fa-cloud-arrow-up']);
            DomHelper.appendNode(buttonSafeNode, 'span', [], [], 'Klasse speichern');
            buttonSafeNode.addEventListener('click', function (event) {
                event.preventDefault();
                console.log("safe", formNode);
                const formData = new FormData(formNode);
                let schoolClass = {
                    id: formData.get('id') ? formData.get('id') : '',
                    longname: formData.get('longname') ? formData.get('longname') : '',
                    shortname: formData.get('shortname') ? formData.get('shortname') : '',
                    von: formData.get('von') ? Util.string2IsoString(formData.get('von')) : '',
                    bis: formData.get('bis') ? Util.string2IsoString(formData.get('bis')) : ''
                };
                modalNode.style.display = 'none';
                sendBackendData('', `/school/${schoolid}/class/${classItem.id}`, 'PUT', 'application/json', bearerToken, schoolClass, (response) => {
                    const responseData = JSON.parse(response.target.response);
                    renderClassUpdate(responseData, schoolid, bearerToken);
                });
            });
        }
    }
}
function addClassInfo(trNode, schoolid, classItem, bearerToken) {
    const tdEditNode = DomHelper.appendNode(trNode, "td", [], []);
    const iNode = DomHelper.appendNode(tdEditNode, 'i', ['fa-light', 'fa-edit'], [{
            attr: 'schoolid',
            value: schoolid
        }], "", classItem.id);
    DomHelper.appendNode(trNode, "td", [], [], classItem.shortname);
    DomHelper.appendNode(trNode, "td", [], [], classItem.longname);
    DomHelper.appendNode(trNode, "td", [], [], Util.isoString2DateString(classItem.von));
    DomHelper.appendNode(trNode, "td", [], [], classItem.bis ? Util.isoString2DateString(classItem.bis) : "--");
    tdEditNode.addEventListener('click', function (event) {
        console.log("handleClassEdit", event);
        handleClassEdit(schoolid, classItem, bearerToken, event);
    });
}
function renderGridRowClass(parentNode, classItem, schoolid, bearerToken) {
    let cssClassList = [];
    const trNode = DomHelper.appendNode(parentNode, "tr", cssClassList, [], "", classItem.id);
    addClassInfo(trNode, schoolid, classItem, bearerToken);
}
function sortClassesByShortname(classes) {
    const sortedClasses = classes.sort((a, b) => {
        if (a.shortname < b.shortname)
            return -1;
        if (a.shortname > b.shortname)
            return 1;
        return 0;
    });
    return sortedClasses;
}
function appPartClassGridRender(schoolUUID, classes, bearerToken) {
    const messageNode = document.getElementById("odSchoolMessage");
    if (messageNode)
        messageNode.innerHTML = "";
    DomHelper.appendNode(messageNode, 'div', ['rudi-msg-neutral'], [], "In der folgenden Liste sehen Sie alle Klassen Ihrer Schule. Klassen können zeitlich begrenzt werden aber nicht gelöscht werden. <br> Das Kürzel wird zur Anzeige in Listen verwendet und zusammen mit dem Kürzel der Schule wird daraus der Chatraum-Name ermittelt. Das Kürzel ist unveränderlich.");
    const gridNode = document.getElementById("odSchoolGrid");
    if (gridNode) {
        gridNode.innerHTML = "";
        gridNode.setAttribute("schoolid", schoolUUID);
        const tableNode = DomHelper.appendNode(gridNode, "table", [], [], "");
        renderGridClassHeaderRow(tableNode, classes, bearerToken);
        const tbodyNode = DomHelper.appendNode(tableNode, "tbody", [], [], "", 'rudi-class-table-body');
        const sortedClasses = sortClassesByShortname(classes);
        for (let classItem of sortedClasses) {
            renderGridRowClass(tbodyNode, classItem, schoolUUID, bearerToken);
        }
        const buttonAddClassNode = DomHelper.appendNode(gridNode, "button", ['btn', 'btn-secondary'], [], '');
        DomHelper.appendNode(buttonAddClassNode, 'i', ['fa-light', 'fa-plus']);
        DomHelper.appendNode(buttonAddClassNode, 'span', [], [], 'Neue Klasse');
        buttonAddClassNode.addEventListener('click', function (event) {
            console.log("handleClassEdit", event);
            handleClassCreate(schoolUUID, bearerToken, event);
        });
    }
}
function appPartSchoolGridRender(schoolUUID, classes, bearerToken) {
    const sortedClasses = sortClassesByShortname(classes);
    const activeClasses = Util.filterActiveClasses(sortedClasses);
    const messageNode = document.getElementById("odSchoolMessage");
    if (messageNode)
        messageNode.innerHTML = "";
    DomHelper.appendNode(messageNode, 'div', ['rudi-msg-neutral'], [], "In der folgenden Liste sehen Sie alle Lernenden, die noch keiner Klasse zugewiesen sind. Sollte die Liste leer sein klicken Sie auf eine Klassenbezeichnung in der Tabelle um die Lernenden der Klasse anzuzeigen.<br><em>Ein Klick auf einen der Buttons neben den Namen der Lernenden speichert die Klassenzuordnung ohne weitere Dialoge.</em>");
    const gridNode = document.getElementById("odSchoolGrid");
    if (gridNode) {
        gridNode.innerHTML = "";
        gridNode.setAttribute("schoolid", schoolUUID);
        const tableNode = DomHelper.appendNode(gridNode, "table", [], [], "");
        renderGridHeaderRow(tableNode, bearerToken);
        const tbodyNode = DomHelper.appendNode(tableNode, "tbody", [], [], "");
        classes.sort((a, b) => {
            if (a.longname > b.longname)
                return 1;
            else if (a.longname < b.longname)
                return -1;
            else
                return 0;
        });
        for (let classItem of classes) {
            renderGridRow(tbodyNode, classItem, bearerToken);
        }
    }
}
function renderFunctionButton(parentNode, selector, schoolUUID, username, bearerToken, activeSelector) {
    let cssClassList = ['rudi-school-class-btn'];
    if (selector.type == activeSelector)
        cssClassList.push("active");
    const buttonNode = DomHelper.appendNode(parentNode, "button", cssClassList, [{ attr: "schoolid", value: schoolUUID }], selector.label, selector.type);
    buttonNode.addEventListener('click', function (event) {
        handleFunctionSelection(event, username, bearerToken);
    });
}
function updateFunctionButtonActiveState(activeSelector) {
    const functionNode = document.getElementById("odSchoolFunctionSelector");
    for (let button of functionNode.getElementsByTagName("button")) {
        button.classList.remove('active');
        if (button.getAttribute('id') === activeSelector) {
            button.classList.add('active');
        }
    }
}
function appPartFunctionRender(username, schoolUUID, classes, pupils, bearerToken, activeSelector) {
    const messageNode = document.getElementById("appPartFunctionRender");
    const functionNode = document.getElementById("odSchoolFunctionSelector");
    if (functionNode) {
        functionNode.innerHTML = "";
        for (let selector of functionList) {
            renderFunctionButton(functionNode, selector, schoolUUID, username, bearerToken, activeSelector);
        }
    }
}
function renderGridHeaderRow(parentNode, bearerToken) {
    const theadNode = DomHelper.appendNode(parentNode, "thead", [], [], "");
    const trNode = DomHelper.appendNode(theadNode, "tr", [], [], "");
    DomHelper.appendNode(trNode, "th", [], [], "Klasse / Gruppe");
    DomHelper.appendNode(trNode, "th", [], [], "noch nicht eingeladen");
    DomHelper.appendNode(trNode, "th", [], [], "keine Telefonnummer");
    DomHelper.appendNode(trNode, "th", [], [], "bereits eingeladen");
    DomHelper.appendNode(trNode, "th", [], [], "Einladen");
    DomHelper.appendNode(trNode, "th", [], [], "Passwort setzen");
}
function renderGridClassHeaderRow(parentNode, classes, bearerToken) {
    const theadNode = DomHelper.appendNode(parentNode, "thead", [], [], "");
    const trNode = DomHelper.appendNode(theadNode, "tr", [], [], "");
    DomHelper.appendNode(trNode, "th", [], [], "");
    DomHelper.appendNode(trNode, "th", [], [], "Kürzel");
    DomHelper.appendNode(trNode, "th", [], [], "Name");
    DomHelper.appendNode(trNode, "th", [], [], "Von");
    DomHelper.appendNode(trNode, "th", [], [], "Bis");
}
function renderGridRow(parentNode, classItem, bearerToken, currentClass) {
    const trNode = DomHelper.appendNode(parentNode, "tr", [], [], "", classItem.id);
    DomHelper.appendNode(trNode, "td", [], [], classItem.shortname);
    const tdNode01 = DomHelper.appendNode(trNode, "td", [], [], "");
    DomHelper.appendNode(tdNode01, "div", [], [], classItem.notInvited ? classItem.notInvited.length + "" : "0");
    DomHelper.addDetail(tdNode01, classItem.notInvited);
    const tdNode02 = DomHelper.appendNode(trNode, "td", [], [], "");
    DomHelper.appendNode(tdNode02, "div", [], [], classItem.noPhone ? classItem.noPhone.length + "" : "0");
    DomHelper.addDetail(tdNode02, classItem.noPhone);
    const tdNode03 = DomHelper.appendNode(trNode, "td", [], [], "");
    DomHelper.appendNode(tdNode03, "div", [], [], classItem.invited ? classItem.invited.length + "" : "0");
    DomHelper.addDetail(tdNode03, classItem.invited);
    const tdNode04 = DomHelper.appendNode(trNode, "td", [], [], "");
    const buttonInvite = DomHelper.appendNode(tdNode04, "button", [], [], "Einladen");
    buttonInvite.addEventListener('click', function (event) {
        console.log("->Event invite", classItem.id);
        let params = {
            classid: classItem.id
        };
        sendBackendData('', `/invite/group/`, 'POST', 'application/json', bearerToken, params, (response) => {
            const responseData = JSON.parse(response.target.response);
            renderInviteClassResult(responseData);
        });
    });
    const tdNode05 = DomHelper.appendNode(trNode, "td", [], [], "");
    const buttonPSW = DomHelper.appendNode(tdNode05, "button", [], [], "Passwort setzen");
    buttonPSW.addEventListener('click', function (event) {
        console.log("->Event psw", classItem.id);
        let password = prompt("Geben Sie das gewünschte Kennwort ein", "MeineAusbildung");
        console.log(password);
        let params = {
            classid: classItem.id,
            password: password
        };
        sendBackendData('', `/invite/password/`, 'POST', 'application/json', bearerToken, params, (response) => {
            const responseData = JSON.parse(response.target.response);
            renderInviteClassResult(responseData);
        });
    });
}
function renderInviteClassResult(responseData) {
    if (DEBUG)
        console.log("renderInviteClassResult", responseData);
    const messageNode = document.getElementById('odSchoolMessage');
    if (messageNode) {
        const tableNode = DomHelper.appendNode(messageNode, 'table', []);
        for (let member of responseData.result.results) {
            const trNode = DomHelper.appendNode(tableNode, 'tr', [`rudi-status-${member.status}`]);
            DomHelper.appendNode(trNode, "td", [], [], member.id);
            DomHelper.appendNode(trNode, "td", [], [], member.message);
        }
    }
}
function renderGridHeaderRowButtons(parentNode, classItem, bearerToken) {
    let cssClassList = ["rudi-school-class-btn", "rudi-school-header"];
    const tdNode = DomHelper.appendNode(parentNode, "th", [], [], "");
    const buttonNode = DomHelper.appendNode(tdNode, "button", cssClassList, [{ attr: "classid", value: classItem.id }], classItem.shortname);
    buttonNode.addEventListener('click', function (event) {
        handleClassSelection(event, bearerToken);
    });
}
function renderGridRowButtons(parentNode, classItem, pupil, bearerToken) {
    let cssClassList = ["rudi-school-class-btn"];
    if (pupil.odSchoolClass === classItem.id) {
        cssClassList.push("active");
    }
    const tdNode = DomHelper.appendNode(parentNode, "td", [], [], "");
    const buttonNode = DomHelper.appendNode(tdNode, "button", cssClassList, [{ attr: "classid", value: classItem.id }, { attr: "pupilid", value: pupil.cn }], classItem.shortname);
    buttonNode.addEventListener('click', function (event) {
        putPupil2ClassButtonHandler(event, bearerToken);
    });
}
function handleClassSelection(event, bearerToken) {
    console.log("-->handleClassSelection", event);
    if (event && event.target) {
        let target = event.target;
        const buttonNode = DomHelper.getFirstParentWithClass(target, "rudi-school-class-btn");
        const gridNode = document.getElementById("odSchoolGrid");
        let classid = buttonNode.getAttribute("classid");
        console.log(buttonNode.getAttribute("classid"));
        if (gridNode) {
            const theadNode = gridNode.querySelector("thead");
            if (theadNode) {
                const thList = theadNode.getElementsByTagName("th");
                for (let thItem of thList) {
                    const button = thItem.querySelector("button");
                    if (button && button.getAttribute("classid") == classid) {
                        thItem.classList.add("active");
                    }
                    else {
                        thItem.classList.remove("active");
                    }
                }
            }
            const tbodyNode = gridNode.querySelector("tbody");
            if (tbodyNode) {
                for (let row of tbodyNode.children) {
                    const buttonNode = row.querySelector('button.active[classid="' + classid + '"]');
                    if (buttonNode) {
                        row.classList.remove("disabled");
                    }
                    else {
                        row.classList.add("disabled");
                    }
                }
            }
        }
    }
}
function handleFunctionSelection(event, username, bearerToken) {
    console.log("-->handleFunctionSelection", event);
    if (event && event.target) {
        let target = event.target;
        const buttonNode = DomHelper.getFirstParentWithClass(target, "rudi-school-class-btn");
        const gridNode = document.getElementById("odSchoolGrid");
        let schoolUUID = buttonNode.getAttribute("schoolid");
        let type = buttonNode.getAttribute("id");
        console.log("-->handleFunctionSelection", schoolUUID, type);
        if (type)
            updateFunctionButtonActiveState(type);
        if (type === "pupil") {
            getBackendData(username, "/school/" + schoolUUID + "/", "GET", "application/json", bearerToken, function (response) {
                const responseData = JSON.parse(response.target.response);
                console.log(responseData);
                const classes = responseData[0].classes;
                const schoolUUID = responseData[0].id;
                if (schoolUUID != "empty") {
                    getBackendData(username, "/school/" + schoolUUID + "/pupil/", "GET", "application/json", bearerToken, function (response) {
                        const responseData = JSON.parse(response.target.response);
                        console.log(responseData);
                        console.log("Classes", classes);
                        appPartFunctionRender(username, schoolUUID, classes, responseData, bearerToken, "pupil"),
                            appPartSchoolGridRender(schoolUUID, classes, bearerToken);
                    });
                }
            });
        }
        else if (type === "classes") {
            getBackendData(username, "/school/" + schoolUUID + "/", "GET", "application/json", bearerToken, function (response) {
                const responseData = JSON.parse(response.target.response);
                console.log(responseData);
                const classes = responseData[0].classes;
                const schoolUUID = responseData[0].id;
                appPartClassGridRender(schoolUUID, classes, bearerToken);
            });
        }
    }
}
function putPupil2ClassButtonHandler(event, bearerToken) {
    console.log("-->putPupil2ClassButtonHandler", event);
    if (event && event.target) {
        let target = event.target;
        const buttonNode = DomHelper.getFirstParentWithClass(target, "rudi-school-class-btn");
        const gridNode = document.getElementById("odSchoolGrid");
        let schoolid = gridNode != null ? gridNode.getAttribute("schoolid") : "";
        let pupilid = buttonNode.getAttribute("pupilid");
        let classid = buttonNode.getAttribute("classid");
        const tdStatusNode = document.getElementById("status_" + pupilid);
        if (tdStatusNode) {
            let cssClasses = ['fa-light', 'fa-spinner-scale', 'fa-spin', 'fa-2xl'];
            tdStatusNode.innerHTML = "";
            DomHelper.appendNode(tdStatusNode, "i", cssClasses, [], "", "icon_" + pupilid);
            getBackendData("", `/school/${schoolid}/class/${classid}/pupil/${pupilid}`, "PUT", "application/json", bearerToken, putPupil2ClassResopnseHandler);
        }
    }
}
function putPupil2ClassResopnseHandler(response) {
    const responseData = JSON.parse(response.target.response);
    console.log("-->putPupil2ClassResopnseHandler", responseData);
    let pupilid = responseData.pupilid;
    let classid = responseData.classid;
    const trNode = document.getElementById(pupilid);
    const iconNode = document.getElementById("icon_" + pupilid);
    console.log("-->result of trNode", trNode);
    if (trNode) {
        const activeButton = trNode.querySelector('.rudi-school-class-btn.active');
        console.log("-->result of activeButton", activeButton);
        if (activeButton)
            activeButton.classList.remove("active");
        const currentButton = trNode.querySelector('button[classid="' + classid + '"]');
        console.log("-->result of activeButton", activeButton);
        if (currentButton)
            currentButton.classList.add("active");
    }
    if (iconNode) {
        iconNode.classList.remove("fa-spinner-scale");
        iconNode.classList.remove("fa-spin");
        iconNode.classList.add("fa-check");
    }
}
function handleClickOpen(event, username, bearerToken, userPreferences) {
    const additionalClassList = [];
    const appGroupNode = document.getElementById('appGroups');
    if (appGroupNode)
        appGroupNode.classList.add('disabled');
    const fullScreenNode = document.getElementById('appFullscreen');
    if (fullScreenNode) {
        fullScreenNode.classList.remove('disabled');
        createButtonClose(fullScreenNode, username, bearerToken, userPreferences);
        DomHelper.appendNode(fullScreenNode, 'h1', additionalClassList, [], "Einladung zu RuDi#Key");
        getSchoolAdminMainStructure(fullScreenNode, additionalClassList);
        DomHelper.appendNode(fullScreenNode, 'section', additionalClassList, [], "", "odSchoolGrid");
    }
    getBackendData(username, "/school/", "GET", "application/json", bearerToken, function (response) {
        const responseData = JSON.parse(response.target.response);
        const selectorNode = document.getElementById('odSchoolSelector');
        if (selectorNode)
            appPartSchoolSelectorRender(selectorNode, username, userPreferences, responseData, bearerToken);
    });
}
function createButtonClose(injectNode, username, bearerToken, userPreferences) {
    const buttonNode = DomHelper.appendNode(injectNode, 'button', ['btn', 'btn-primary', 'mt-2'], [{
            attr: 'id',
            value: 'rudi-sap-asp-btn-hide'
        }]);
    DomHelper.appendNode(buttonNode, 'i', ['fa-light', 'fa-arrow-up', 'me-1'], []);
    DomHelper.appendNode(buttonNode, 'span', [], [], 'schließen');
    buttonNode.addEventListener('click', function (event) {
        console.log("->Event close", event);
        const appGroupNode = document.getElementById('appGroups');
        if (appGroupNode)
            appGroupNode.classList.remove('disabled');
        const fullScreenNode = document.getElementById('appFullscreen');
        if (fullScreenNode) {
            fullScreenNode.innerHTML = "";
            fullScreenNode.classList.add('disabled');
        }
    });
}
